<template>
  <div id="noproject">
    <div style="background:#fff;width: 100%;height:100%">
      <div class="box">
        <img :src="permisson_png" />
        <p style="font-size: 16px; color: #000; margin-top: 36px;text-align: center;"> 该项目下暂未分配对应角色，请联系项目负责人策划对应角色 </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nopermisson",
  data() {
    return {
      permisson_png: require("@/CommonDP/pages/mainMg/error/assets/u5009.png")
    };
  }
};
</script>

<style lang="scss" scoped>
#noproject {
  height: 100%;
  background: #eff1f6;
  padding: 14px;
  .box {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
}
</style>
